import { Box, HStack, Image, Text, VStack } from "native-base";
import { useLocation } from "react-router-dom";
import CustomButton from "../../../../components/button";
import { COMMONFONTSIZE, COMMONFONTWEIGHT } from "../../../../utils/fonts";
import "./style.css";
import WebHeader from "../../../../layout/header/webHeader";
import { COLORS } from "../../../../utils/colors";
import { useSelector } from "react-redux";

const CventWebLandingPageBanner = () => {
  const location = useLocation();
  const activeTab = useSelector((state) => {
    return state.event.activeTab;
  });
  const eventTab = activeTab === "event" ? "Event" : "MICE";

  function bannerText() {
    return (
      <VStack>
        <Text
          fontSize={"54px"}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          pt={2}
        >
          Looking for a better
        </Text>
        <Text fontSize={"54px"} fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}>
          event planner?
        </Text>
        <Text
          fontSize={COMMONFONTSIZE.LARGE_FONT_SIZE}
          fontWeight={COMMONFONTWEIGHT.SMALL_FONT_WEIGHT}
          color={COLORS.PARTNERS_HEADING_COLOR}
        >
          Cvent makes your life simple with minimal clicks
        </Text>
        <Text mt={"40px"}></Text>
        <a
          style={{ textDecoration: "none" }}
          href="https://www.cvent.com/in"
          target="_blank"
          rel="noopener noreferrer"
        >
          <CustomButton
            onClick={() => window.open("https://www.cvent.com/in", "_blank")}
            text="Connect with Cvent"
            width="fit-content"
            py="10px"
          />
        </a>
      </VStack>
    );
  }

  return (
    <Box bg={COLORS.WHITE_COLOR}>
      <Box pt={3} pb={1}>
        <WebHeader mt={0} />
      </Box>
      {/* <div className="cvent-landing-page-banner-container" p={"20px"}>
        <HStack flex={1} w="100%" h="100%">
          <Box w={"50%"} alignItems={"center"} justifyContent={"center"}>
            <Image
              source={{
                uri: require("../../../../utils/quickLinkImages/cvent-banner-web.png"),
              }}
              alt="image"
              width="400px"
              height="300px"
            />
          </Box>
          <Box w={"50%"} pt="1.5rem" pr={"50px"} pb={"3.5rem"}>
            {bannerText()}
          </Box>
        </HStack>
      </div> */}
    </Box>
  );
};

export default CventWebLandingPageBanner;
